import { fetchLimitedInitialChatState } from '@/store/thunks/FetchThreads';
import { loginUser } from '@/store/thunks/LoginUser';
import { useAppDispatch } from '@/store/hooks';
import { useAuth0 } from '@/auth/Auth0Client';
import { useDebounce } from '@/hooks/browserHooks';

import { useEffect } from 'react';

export const useInitUserAndThreads = (): void => {
  const { auth0User } = useAuth0();
  const dispatch = useAppDispatch();
  const debouncedInitializeUser = useDebounce(async (user) => {
    dispatch(loginUser(user || null));
    // TODO: switch to fetchInitialChatState once GQL pagination is set up
    // fetchLimitedInitialChatState fetches the latest 50 threads from the rest api
    dispatch(fetchLimitedInitialChatState());
  }, 500);

  useEffect(() => {
    debouncedInitializeUser(auth0User);
  }, [auth0User, debouncedInitializeUser]);
};
